import { render, staticRenderFns } from "./FormCourseAlias.vue?vue&type=template&id=7b82c68e&scoped=true&"
import script from "./FormCourseAlias.vue?vue&type=script&lang=js&"
export * from "./FormCourseAlias.vue?vue&type=script&lang=js&"
import style0 from "./FormCourseAlias.vue?vue&type=style&index=0&id=7b82c68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82c68e",
  null
  
)

export default component.exports